import * as types from './mutation-types'

export default {
  changeAppLoadingStatus(state, data) {
    state.isAppLoaded = data
  }
}
